import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQS = [
  {
    q: "Can I change plans at any time?",
    a: "Yes. Upgrade or downgrade in one click. You'll be charged or refunded the prorated difference at the next billing cycle.",
  },
  {
    q: "What happens after my 14-day free trial?",
    a: "We'll email you 3 days before the trial ends. You can pick a plan or your account will pause read-only — you never lose your data or audit trail.",
  },
  {
    q: "Where is my data stored?",
    a: "Exclusively in the UK on AWS London (eu-west-2). Data never leaves the UK. We sign a Data Processing Agreement on request and our default DPA template is available to download.",
  },
  {
    q: "Which FCA rules do you check against?",
    a: "FCA Financial Promotions (FSMA s.21, COBS 4), Consumer Duty principles, ASA / CAP Code for advertising, and ICO / UK GDPR for communications. Enterprise plans support custom rulesets for niche permissions.",
  },
  {
    q: "Can multiple advisors use one account?",
    a: "Yes — Professional and Enterprise plans include unlimited team members with granular role-based permissions (Firm Admin, Compliance Manager, Advisor, Read-Only).",
  },
  {
    q: "What if I need to export all my firm's data?",
    a: "Any firm admin can export your entire firm — including the immutable audit trail — at any time, free of charge. CSV + PDF formats supported.",
  },
  {
    q: "Is the audit trail really immutable?",
    a: "Yes. Each event is cryptographically chained via SHA-256 with the previous record's hash. No user, not even our super-admins, can delete or alter audit records. Retention is 7 years to meet FCA requirements.",
  },
];

export default function FAQ() {
  return (
    <section className="py-24 bg-surface" data-testid="faq-section">
      <div className="max-w-3xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-12">
          <div className="t-label text-indigo2 mb-3">Common questions</div>
          <h2 className="t-display">Everything you need to know.</h2>
        </div>
        <Accordion type="single" collapsible className="space-y-3">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`faq-${i}`}
              className="card2 px-6 border-b"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger className="t-h4 hover:no-underline py-5 text-left">{f.q}</AccordionTrigger>
              <AccordionContent className="t-body text-slate2 pb-5">{f.a}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
